import React, { useEffect, useRef } from 'react';
import { EDITOR_COPY, LINK_BAR } from './editorCopy';

/**
 * Row 3 of the sticky header: the link / image / video bar (prototype
 * `wkLinkOpen`). The input is focused and selected 30 ms after opening; Enter
 * inserts, Escape cancels.
 */
export default function WikiLinkBar({ link, onChange, onApply, onCancel }) {
    const inputRef = useRef(null);
    const openedAt = link ? link.n : null;

    useEffect(() => {
        if (openedAt == null) return undefined;
        const t = setTimeout(() => {
            const input = inputRef.current;
            if (!input) return;
            input.focus();
            input.select();
        }, 30);
        return () => clearTimeout(t);
    }, [openedAt]);

    if (!link) return null;
    const copy = LINK_BAR[link.kind] || LINK_BAR.link;
    return (
        <div className="wk-ed-linkbar" data-testid="wiki-editor-linkbar">
            <label className="wk-ed-linkbar-label" htmlFor="wk-ed-link-input">{copy.label}</label>
            <input
                id="wk-ed-link-input"
                ref={inputRef}
                data-wklink="1"
                className="wk-ed-linkbar-input"
                value={link.url}
                placeholder={copy.placeholder}
                onChange={(event) => onChange(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        onApply();
                    } else if (event.key === 'Escape') {
                        event.preventDefault();
                        onCancel();
                    }
                }}
            />
            <button type="button" className="wk-ed-linkbar-insert" data-testid="wiki-editor-link-insert" onClick={onApply}>
                {EDITOR_COPY.linkInsert}
            </button>
            <button type="button" className="wk-ed-linkbar-cancel" data-testid="wiki-editor-link-cancel" onClick={onCancel}>
                {EDITOR_COPY.linkCancel}
            </button>
        </div>
    );
}
